import {fetchPerms} from '../Report/DataHelpers'

export default async function SitePerms (props) {
  const site = props?.getActiveSite();
  if (site) {
    const perms = cachedPerms (site);
    if (perms?.outcome) 
      return perms;
    const tryPerms = await fetchPerms(props)
    //console.log (tryPerms?.response?.data?.data?.result)
    const result = tryPerms?.data?.data?.result ? tryPerms.data.data: 
                  tryPerms?.response?.data?.data
    props.updateSiteListCache ('perms', result)
    return result
  }
  return site;
}
export function cachedPerms(site) {
  return site?.perms?.result
}
export function reason (resp) {
  return resp?.result?.reason ?? ''
}
export function canRead (outcome) {
  const strOutcome = outcome ?? ""
  return strOutcome.toLowerCase().startsWith('success_r')
}
export function canWrite(perms) {
  const test = perms?.outcome ?? ""
  return !test?.toUpperCase().startsWith('SUCCESS_RO')
}
export function permitted (resp) {
  const outcome = resp?.result?.outcome ?? resp?.outcome
  return canRead(outcome)
}
export function grantRequired (resp) {
  if (!permitted(resp)) {
    //console.log (reason(resp).toLowerCase())
    return 0 === 'no_access'.localeCompare(reason(resp).toLowerCase())
  }
  return false;
}
